import { childrenToArray } from '@/lib/utils';
import styles from './ScrolledGrid.module.css';

import type { FunctionComponent } from 'react';
import type { TypeScrolledGridProps } from './types';

/**
 * ScrolledGrid
 */
export const ScrolledGrid: FunctionComponent<TypeScrolledGridProps> = ({
  className = '',
  numCol = 4,
  minWidthElement = 'var(--card-size-s-w)',
  withSteps = false,
  children,
}: TypeScrolledGridProps) => (
  <div className={`${styles['c-scrolled-grid']} ${className}`}>
    <div className={styles['c-scrolled-grid__scroll']}>
      <div
        className={styles['c-scrolled-grid__grid']}
        style={{
          gridTemplateColumns: `repeat(${numCol}, minmax(0, 1fr))`,
          minWidth: `calc(${minWidthElement} * ${numCol})`,
        }}
      >
        {childrenToArray(children).map((child, index) =>
          withSteps ? (
            <div
              className={styles['c-scrolled-grid__item']}
              key={`item-${index}`}
            >
              <span
                className={styles['c-scrolled-grid__step']}
                aria-hidden="true"
              >
                {index + 1}
              </span>

              <div className={styles['c-scrolled-grid__child']}>{child}</div>
            </div>
          ) : (
            child
          )
        )}
      </div>
    </div>
  </div>
);
